<template>
    <v-dialog
      v-model="dialog"
      scrollable
      max-width="750px">
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" style="cursor: pointer;">
            <v-icon style="cursor:pointer;">
                {{ archiveIcon }}
            </v-icon>
            <span>{{ archiveAction }} Integration</span>
        </div>
      </template>
      <v-card>
        <v-card-title>Confirm {{ archiveAction }} Integration</v-card-title>
        <v-card-text>Are you sure you want to {{ archiveAction }} {{ integration.label }}? </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary darken-1" text @click="onConfirm">Confirm</v-btn>
          <v-btn color="red darken-1" text @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>

  <script>
  import { EventBus } from '@/js/event-bus.js';

  export default {
    props: {
      id: {
        type: Number,
        required: true,
      },
      integration: {
        type: Object,
        required: true,
      },
    },

    computed: {
      archiveIcon() {
        return this.integration.deleted_at ? 'mdi-archive-arrow-up-outline' : 'mdi-archive-outline'
      },

      archiveAction() {
        return this.integration.deleted_at ? 'Restore' : 'Archive'
      }
    },

    data() {
      return {
        dialog: false,
      };
    },

    methods: {

      onConfirm() {

        this.dialog = false

        if (this.integration.deleted_at) {
          this.restoreIntegration()
        } else {
          this.archiveIntegration()
        }
      },

      archiveIntegration() {

        this.$http
            .delete('/api/integrations/' + this.id)
            .then(({ data }) => {
                EventBus.$emit('show-success', 'Successfully archived ' + this.integration.label)

                // redirect to integrations page
                setTimeout(function() {
                  this.$router.push('/integrations')
                }.bind(this), 1000);
            })
            .catch(err => {
                EventBus.$emit('show-error', err)
            })
      },

      restoreIntegration() {
        this.$http
            .post('/api/integrations/restore/' + this.id)
            .then(({ data }) => {
                EventBus.$emit('show-success', 'Successfully restore ' + this.integration.label)

                // redirect to integrations page
                setTimeout(function() {
                  window.location.reload()
                }.bind(this), 1000)
            })
            .catch(err => {
                EventBus.$emit('show-error', err)
            })
      }
    }
  };
  </script>
